import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogConfigInterface} from 'appShared/components';
import {ApiError, ClientAccountBundleSummaryInterface, SesService, UserAccountSubscriptionInterface} from '@spa/api';
import {UpdateSubscriptionForm} from 'appEntries/panel/forms';
import {MarketDataFeedSubscriptionFormErrorStatesEnum, MarketDataFeedUserTypesEnum} from 'appEntries/panel/enums';
import {MarketDataFeedSubscriptionMessages} from 'appAssets/messages';
import {ApiResponse} from '@spa/api/lib/common';
import {PanelBaseMarketDataDialogComponent} from '../panel-base-market-data-dialog.component';
import {PermissionRuleInterface} from 'appShared/interfaces';
import {AlertsService, CurrencyService} from 'appShared/services';
import {AlertTypesEnum} from 'appShared/enums';
import {SesPermissionService} from 'appEntries/panel/services';

@Component({
    selector: 'app-market-data-edit-subscription',
    templateUrl: './market-data-edit-subscription.component.html',
    styleUrls: ['./market-data-edit-subscription.component.scss']
})
export class MarketDataEditSubscriptionComponent extends PanelBaseMarketDataDialogComponent<MarketDataEditSubscriptionComponent> {
    @Input() public clientAccountAndBundleData: ClientAccountBundleSummaryInterface;
    @Input() public subscription: UserAccountSubscriptionInterface;
    @Input() public setMarkupPermission: PermissionRuleInterface;
    @Input() public userType: MarketDataFeedUserTypesEnum;
    @Input() public offsetAccountId: string;
    public hasViewSubscriptionPrice: boolean;
    public hasSetSubscriptionPrice: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            subscription: UserAccountSubscriptionInterface,
            clientAccountAndBundleData: ClientAccountBundleSummaryInterface,
            setMarkupPermission: PermissionRuleInterface,
            userType: MarketDataFeedUserTypesEnum,
            offsetAccountId: string,
        },
        public dialogRef: MatDialogRef<MarketDataEditSubscriptionComponent>,
        private readonly sesService: SesService,
        private readonly currencyService: CurrencyService,
        private readonly sesPermissionService: SesPermissionService,
        private readonly alertsService: AlertsService,
    ) {
        super(dialogRef);
        this.config = data.config;
        this.subscription = data.subscription;
        this.clientAccountAndBundleData = data.clientAccountAndBundleData;
        this.setMarkupPermission = data.setMarkupPermission;
        this.userType = data.userType;
        this.offsetAccountId = data.offsetAccountId;
        this.isServiceUser = this.userType === MarketDataFeedUserTypesEnum.ServiceUser;
        this.hasViewSubscriptionPrice = this.sesPermissionService.hasViewSubscriptionPricePermission();
        this.hasSetSubscriptionPrice = this.sesPermissionService.hasSetSubscriptionPricePermission();
    }

    handleErrorResponse(response: ApiResponse<ApiError[] | boolean>) {
        (response.data as ApiError[]).map((error: ApiError) => {

            if (Array.isArray(response.messages) && response.messages[0]) {
                return response.messages[0];
            }

            if (error.status === MarketDataFeedSubscriptionFormErrorStatesEnum.UpdateMarketDataFeedSubscriptionFailed) {
                return MarketDataFeedSubscriptionMessages.UpdateMarketDataFeedSubscriptionFailed.message;
            }

            return MarketDataFeedSubscriptionMessages.UnknownError.message;

        }).filter((errorMessage: string) => {
            return errorMessage.trim();
        }).forEach((errorMessage: string) => {
            this.alertsService.addAlert(errorMessage);
        });
    }

    initForm(): void {
        this.form = new UpdateSubscriptionForm(this.sesService,this.currencyService, this.subscription, this.clientAccountAndBundleData, this.offsetAccountId);
        this.form.initForm();
    }

    showSuccessFormMessage(): void {
        this.alertsService.addAlert(
            MarketDataFeedSubscriptionMessages.UpdateMarketDataFeedSubscriptionSuccess.message,
            AlertTypesEnum.Success
        );
    }
}
